import React, { memo, useContext, useEffect, useReducer } from 'react';
import { useSnackbar } from 'notistack';
import { context } from '../../../../globalState/GlobalState';
import { isValidObject } from '../../../../catalog/Validity';
import { fetchLinkedProductsAPI, fetchProductsAPI } from '../../../apiCalls/ProductAPICalls';
import { showProducts } from '../../../../catalog/Store';
import FeaturedProducts3 from '../../products1/FeaturedProducts3';

const initialState = {
    products: [],
    linkedProducts: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchProducts':
            return { ...state, products: action.products };
        case 'fetchLinkedProducts':
            return { ...state, linkedProducts: action.linkedProducts };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const HomePage1Section15 = () => {
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetch() {
            if (isValidObject(globalState.accountId)) {
                setState({ type: 'setLoadingSpinner', loadingSpinner: true });
                await fetchProductsAPI(globalState.accountId, globalState, setState, enqueueSnackbar);
                await fetchLinkedProductsAPI(globalState.accountId, setState, enqueueSnackbar);
                setState({ type: 'setLoadingSpinner', loadingSpinner: false });
            }
        }
        fetch();
    }, [globalState.accountId]);

    const getFeaturedProducts = () => {
        const featuredProducts = state.products.filter((product) => {
            return product.featureProduct && !product.deleted && product.published && !product.archived;
        });
        const linkedFeaturedProducts = state.linkedProducts.filter((product) => {
            return product.featureProduct && !product.deleted && product.published && !product.archived;
        });
        if (!showProducts(globalState, [...featuredProducts, ...linkedFeaturedProducts])) {
            return [];
        }
        return [...featuredProducts, ...linkedFeaturedProducts];
    };

    return (
        <>
            {getFeaturedProducts().length > 0 ? <FeaturedProducts3 products={getFeaturedProducts()} title="Store" /> : null}
        </>
    );
};

export default memo(HomePage1Section15);
